import * as core from '../../../../../../../core'
import * as orgJointUseCalcMode from '../org-joint-use-calculation-mode'

export const RESOURCE = {
  payload: {
    description: 'Manual',
    enumId: core.dms.models.Enum.Id.from({
      partialId: orgJointUseCalcMode.RESOURCE.payload.partialId,
    }),
    id: 'MANUAL',
    name: 'Manual',
  },
  type: core.quiver.Resource.Type.DmsEnumEntry,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
